/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, Label, Spacer } from "@nordcloud/gnui";
import { PremiumSupportCSPSelect } from "~/components/Filters/PremiumSupportCSPSelect";
import { isNotEmptyObj, useQueryState } from "~/tools";
import { Fieldset } from "../Forms";
import { LoaderWrap } from "../LoaderWrap/LoaderWrap";
import FlexContainer from "../Styled/FlexContainer";
import { CategoryMultiSelect } from "./CategoryMultiSelect";
import { ProviderMultiSelect } from "./ProviderMultiSelect";
import { FiltersProp } from "./types";

type Props = {
  onClose: () => void;
  filters: FiltersProp;
  setFilters: (filter: FiltersProp) => void;
};

export function Filters({ onClose, filters, setFilters }: Props) {
  const [, set] = useQueryState();

  const commit = () => {
    set("filters")(filters);
    onClose();
  };

  const reset = () => {
    set("filters")({});
    onClose();
  };
  const hasFilters = isNotEmptyObj(filters);
  const isDisabled = !hasFilters;

  return (
    <LoaderWrap loading={false} inContent>
      <Fieldset>
        <Label name="Cloud provider" />
        <ProviderMultiSelect
          value={filters.provider ?? []}
          filters={filters}
          setFilters={setFilters}
        />
      </Fieldset>

      <Fieldset>
        <Label name="Customer Category" />
        <CategoryMultiSelect
          value={filters.category ?? []}
          filters={filters}
          setFilters={setFilters}
        />
      </Fieldset>

      <Fieldset>
        <Label name="Premium Support CSP" />
        <PremiumSupportCSPSelect
          value={filters.premiumSupportCSP ?? []}
          filters={filters}
          setFilters={setFilters}
        />
      </Fieldset>
      <Spacer height="1rem" />

      <FlexContainer justify="space-between">
        <Button onClick={commit} disabled={isDisabled}>
          Apply filters
        </Button>
        <Button onClick={reset} severity="low" disabled={isDisabled}>
          Clear filters &amp; reload
        </Button>
      </FlexContainer>
    </LoaderWrap>
  );
}
